import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getHasta, getAnamnezBasliklar, yeniMuayene } from '../services/api';

export default function MuayeneYeni() {
  const { kayitNo } = useParams();
  const navigate = useNavigate();

  const [hasta, setHasta] = useState(null);
  const [basliklar, setBasliklar] = useState({
    blg1: 'Şikayeti', blg2: 'Hikayesi', blg3: 'Fizik Muayene', blg4: 'Tedavi Planı'
  });
  const [blg1, setBlg1] = useState('');
  const [blg2, setBlg2] = useState('');
  const [blg3, setBlg3] = useState('');
  const [blg4, setBlg4] = useState('');
  const [kontrol, setKontrol] = useState(false);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');

  useEffect(() => {
    getHasta(kayitNo).then(r => setHasta(r.data)).catch(() => setHata('Hasta bulunamadı.'));
    getAnamnezBasliklar().then(r => setBasliklar(r.data)).catch(() => {});
  }, [kayitNo]);

  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
  const dokKod = kullanici.dokKod || kullanici.noo || 0;

  const kaydet = async (e) => {
    e.preventDefault();
    if (!blg1.trim() && !blg2.trim() && !blg3.trim() && !blg4.trim()) {
      setHata('En az bir muayene alanı doldurulmalıdır.');
      return;
    }
    setHata('');
    setKaydediliyor(true);
    try {
      const res = await yeniMuayene({ kayitNo: parseInt(kayitNo), dokKod, blg1, blg2, blg3, blg4, kontrol });
      navigate(`/muayene/${res.data.id}`);
    } catch {
      setHata('Muayene kaydedilemedi. Lütfen tekrar deneyin.');
    } finally {
      setKaydediliyor(false);
    }
  };

  if (hata && !hasta) return <div className="kart kart-pad">{hata}</div>;
  if (!hasta) return <div className="kart kart-pad">Yükleniyor…</div>;

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span onClick={() => navigate(`/hasta/${kayitNo}/muayeneler`)}
              style={{ color: 'var(--mor)', cursor: 'pointer', fontSize: 13.5, fontWeight: 600 }}>
          ← Muayene geçmişine dön
        </span>
      </div>

      {/* Hasta başlığı */}
      <div className="kart kart-pad" style={{ marginBottom: 18 }}>
        <h1 className="sayfa-baslik" style={{ marginBottom: 6 }}>Yeni Muayene</h1>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <span className="bilgi-rozet">{hasta.hesapAdi}</span>
          <span className="bilgi-rozet">Hasta No: {hasta.kayitNo}</span>
          {hasta.yas != null && <span className="bilgi-rozet">{hasta.yas} yaş</span>}
        </div>
      </div>

      <form onSubmit={kaydet}>
        <div className="kart kart-pad" style={{ marginBottom: 14 }}>
          <div className="bolum-baslik">{basliklar.blg1}</div>
          <textarea className="input" rows={4}
            style={{ width: '100%', marginTop: 6, resize: 'vertical', fontFamily: 'inherit', fontSize: 14 }}
            value={blg1} onChange={e => setBlg1(e.target.value)}
            placeholder={basliklar.blg1 + ' yazın…'} />
        </div>

        <div className="kart kart-pad" style={{ marginBottom: 14 }}>
          <div className="bolum-baslik">{basliklar.blg2}</div>
          <textarea className="input" rows={4}
            style={{ width: '100%', marginTop: 6, resize: 'vertical', fontFamily: 'inherit', fontSize: 14 }}
            value={blg2} onChange={e => setBlg2(e.target.value)}
            placeholder={basliklar.blg2 + ' yazın…'} />
        </div>

        <div className="kart kart-pad" style={{ marginBottom: 14 }}>
          <div className="bolum-baslik">{basliklar.blg3}</div>
          <textarea className="input" rows={6}
            style={{ width: '100%', marginTop: 6, resize: 'vertical', fontFamily: 'inherit', fontSize: 14 }}
            value={blg3} onChange={e => setBlg3(e.target.value)}
            placeholder={basliklar.blg3 + ' yazın…'} />
        </div>

        <div className="kart kart-pad" style={{ marginBottom: 14 }}>
          <div className="bolum-baslik">{basliklar.blg4}</div>
          <textarea className="input" rows={4}
            style={{ width: '100%', marginTop: 6, resize: 'vertical', fontFamily: 'inherit', fontSize: 14 }}
            value={blg4} onChange={e => setBlg4(e.target.value)}
            placeholder={basliklar.blg4 + ' yazın…'} />
        </div>

        <div className="kart kart-pad" style={{ marginBottom: 18, display: 'flex', alignItems: 'center', gap: 10 }}>
          <input type="checkbox" id="kontrol" checked={kontrol} onChange={e => setKontrol(e.target.checked)}
                 style={{ width: 18, height: 18, cursor: 'pointer' }} />
          <label htmlFor="kontrol" style={{ cursor: 'pointer', fontWeight: 500 }}>Kontrol muayenesi</label>
        </div>

        {hata && <div className="kart kart-pad" style={{ color: '#c0392b', marginBottom: 14 }}>{hata}</div>}

        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn" type="submit" disabled={kaydediliyor}>
            {kaydediliyor ? '…Kaydediliyor' : '💾 Kaydet'}
          </button>
          <button type="button" className="btn-ikincil"
                  onClick={() => navigate(`/hasta/${kayitNo}/muayeneler`)}>
            İptal
          </button>
        </div>
      </form>
    </div>
  );
}
